import { WorkingWithUsSectionStyles } from '../section.style';
import { desktop } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

const { Content } = WorkingWithUsSectionStyles;

export const ParagraphText = styled.p`
  padding-bottom: 0.5rem;
`;

export const HelpTitle = styled(MDSText.BodyHeavyDefault)`
  color: ${(p) => p.theme.midwestColors.neutralDarkMedium};
`;

export const PaddedContent = styled(Content)<{
  forceMobileBreakpoint?: boolean;
}>`
  gap: 1rem;
  ${({ forceMobileBreakpoint }) =>
    !forceMobileBreakpoint &&
    `
    ${desktop} {
      padding-left: 10rem;
    }
  `}
`;
